import React from 'react';
import { Stack, TextField } from '@mui/material';
import { CptFormErrors } from '../hooks';

interface CategoryGrouperFieldsProps {
    category: string;
    grouperPointer: string;
    errors: CptFormErrors;
    onChange: (field: 'category' | 'grouperPointer', value: string) => void;
}

export const CategoryGrouperFields: React.FC<CategoryGrouperFieldsProps> = ({
    category,
    grouperPointer,
    errors,
    onChange
}) => {
    return (
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            <TextField
                label="Category"
                value={category}
                onChange={(e) => onChange('category', e.target.value)}
                error={!!errors.category}
                helperText={errors.category || 'Optional'}
                size="small"
                sx={{ flex: 1 }}
                inputProps={{ maxLength: 100 }}
                placeholder="Optional"
            />
            <TextField
                label="Grouper Pointer"
                value={grouperPointer}
                onChange={(e) => onChange('grouperPointer', e.target.value)}
                error={!!errors.grouperPointer}
                helperText={errors.grouperPointer || 'Optional'}
                size="small"
                sx={{ flex: 1 }}
                inputProps={{ maxLength: 50 }}
                placeholder="Optional"
            />
        </Stack>
    );
};
